import { Provider } from "@redotech/redo-order-common/provider";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const importPackageLearningCsv = {
  name: "importPackageLearningCsv" as const,
  input: z.object({ teamId: zExt.objectId(), provider: createEnum(Provider) }),
  output: z.object({
    packagesCreated: z.number().int().nonnegative(),
    packagesUpdated: z.number().int().nonnegative(),
    learningPresetsApplied: z.number().int().nonnegative(),
    errors: z.array(z.string()),
  }),
};
